<template>
  <div id="app">
    <div v-if="$store.state.appInfo.site_state == 1">
      <div class="meLoading" v-if="loading">
        <van-loading size="26px" vertical color="#c69a3f" text-color="#9a7b3f">加载中...</van-loading>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />

      <!-- 悬浮客服（进入游戏页隐藏，不打扰） -->
      <div class="floatKf" v-if="$route.path !== '/gamePage'">
        <div class="fkBtn kf" @click="openKefu">
          <img src="/static/image/nav/kf.png" alt="客服" />
          <span>客服</span>
        </div>
        <div class="fkBtn tg" v-if="$store.state.appInfo.tg_url" @click="openTg">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.94 4.9 18.9 19.2c-.23 1.02-.84 1.27-1.7.79l-4.7-3.46-2.27 2.18c-.25.25-.46.46-.94.46l.34-4.78 8.7-7.86c.38-.34-.08-.53-.59-.19L6.3 13.28l-4.64-1.45c-1.01-.32-1.03-1.01.21-1.5l18.14-6.99c.84-.31 1.58.19 1.93 1.56z"></path></svg>
          <span>TG</span>
        </div>
      </div>

      <!-- 转账钱包：进游戏前先转入额度 -->
      <van-popup v-model="gtShow" position="bottom" round :style="{ maxHeight: '80%' }">
        <div class="gtSheet">
          <div class="gtHead">转入游戏额度</div>
          <div class="gtRows">
            <div class="gtRow"><span>中心账户</span><b>￥{{ Number($store.state.userInfo.balance || 0).toFixed(2) }}</b></div>
            <div class="gtRow"><span>游戏账户（{{ gtName }}）</span><b>￥{{ Number(gtGameBalance).toFixed(2) }}</b></div>
          </div>
          <div class="gtField"><input type="number" inputmode="numeric" v-model="gtAmount" placeholder="请输入转入金额" /></div>
          <div class="gtChips">
            <span @click="gtQuick(100)">100</span>
            <span @click="gtQuick(500)">500</span>
            <span @click="gtQuick(1000)">1000</span>
            <span @click="gtQuick('all')">全部</span>
          </div>
          <div class="gtTip" v-if="Number($store.state.userInfo.balance || 0) < 1 && gtGameBalance < 1">中心账户暂无余额，请先充值后再进入游戏</div>
          <div class="gtBtns">
            <button class="gtBtn ghost" @click="gtClose">取消</button>
            <button class="gtBtn direct" v-if="gtGameBalance >= 1" @click="gtEnterDirect">直接进入</button>
            <button class="gtBtn primary" :disabled="gtLoading || Number($store.state.userInfo.balance || 0) < 1" @click="gtConfirm">{{ gtLoading ? '转入中...' : '转入并进入' }}</button>
          </div>
          <div class="gtRecharge" v-if="Number($store.state.userInfo.balance || 0) < 1 && gtGameBalance < 1" @click="gtGoRecharge">去充值 ›</div>
        </div>
      </van-popup>
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      daoTime: null,
      loading: false,
      pid: '',
      // 转账钱包：进游戏前的「转入额度」弹窗
      gtShow: false,
      gtName: '',
      gtType: '',
      gtCode: '',
      gtGameBalance: 0,
      gtAmount: '',
      gtLoading: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;

    that.getApp();
    that.getGameList();

    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
    if (query.pid) {
      that.pid = query.pid;
      that.$router.push({ path: `/login?type=1&pid=${query.pid}` });
    }
    that.getVisitUrl();
  },
  methods: {
    getVisitUrl() {
      let that = this;
      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            let url = that.pid ? res.data.url + 'register?pid=' + that.pid : res.data.url;
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    // 获取游戏列表
    getGameList() {
      let that = this;

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        if (res.code == 200) {
          let list = res.data;
          let realbetList = [];
          let jokerList = [];
          let gamingList = [];
          let sportList = [];
          let lotteryList = [];
          let conciseList = [];
          let fishingList = [];
          list.forEach(el => {
            if (el.category_id == 'realbet' && el.app_state == 1) {
              realbetList.push(el);
            }
            if (el.category_id == 'fishing' && el.app_state == 1) {
              fishingList.push(el);
            }
            if (el.category_id == 'joker' && el.app_state == 1) {
              jokerList.push(el);
            }
            if (el.category_id == 'gaming' && el.app_state == 1) {
              gamingList.push(el);
            }
            if (el.category_id == 'sport' && el.app_state == 1) {
              sportList.push(el);
            }
            if (el.category_id == 'lottery' && el.app_state == 1) {
              lotteryList.push(el);
            }
            if (el.category_id == 'concise' && el.app_state == 1) {
              conciseList.push(el);
            }
          });

          // 电子厂商排序：PG(PGS) 最前、PP(PPS) 次之，其余保持接口 order_by 原序（稳定排序，首页电子+侧栏同源生效）
          var elecPrio = { PGS: 0, PPS: 1 };
          conciseList = conciseList
            .map(function (v, i) {
              return { v: v, i: i };
            })
            .sort(function (a, b) {
              var pa = elecPrio[a.v.platform_name] !== undefined ? elecPrio[a.v.platform_name] : 9;
              var pb = elecPrio[b.v.platform_name] !== undefined ? elecPrio[b.v.platform_name] : 9;
              return pa - pb || a.i - b.i;
            })
            .map(function (o) {
              return o.v;
            });

          localStorage.setItem('realbetList', JSON.stringify(realbetList));
          localStorage.setItem('jokerList', JSON.stringify(jokerList));
          localStorage.setItem('gamingList', JSON.stringify(gamingList));
          localStorage.setItem('sportList', JSON.stringify(sportList));
          localStorage.setItem('lotteryList', JSON.stringify(lotteryList));
          localStorage.setItem('conciseList', JSON.stringify(conciseList));
          localStorage.setItem('fishingList', JSON.stringify(fishingList));
          that.$store.commit('changGameList');
        }
      });
    },
    // 获取app
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    // 退出登录
    outLogin() {
      let that = this;

      that.$dialog
        .confirm({
          title: '提示',
          message: '您确定要退出登录吗?',
        })
        .then(() => {
          that.showLoading();

          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              localStorage.clear();
              sessionStorage.clear();
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/login' });
            })
            .catch(() => {
              localStorage.clear();
              sessionStorage.clear();
              // that.$cookies.remove('token' )/
              that.$store.commit('changUserInfo');
              that.$store.commit('changToken');
              that.closeDaoTime();
              that.hideLoading();
              that.$router.push({ path: '/login' });
            });
        })
        .catch(() => {});
    },
    // 打开游戏：转账钱包模式——先弹「转入额度」弹窗，转入成功或已有额度才进游戏
    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');

        return;
      }
      // 记录进入游戏前的页面，供子游戏页“返回”用（iframe 会污染 history，不能用 $router.back）
      var from = that.$route.fullPath;
      if (!from || from.indexOf('/gamePage') === 0) from = '/';
      sessionStorage.setItem('gameBackPath', from);
      // 打开转入额度弹窗
      that.gtName = name;
      that.gtType = type;
      that.gtCode = code;
      that.gtAmount = '';
      that.gtGameBalance = 0;
      that.gtLoading = false;
      that.gtShow = true;
      that.getBalance(); // 刷新中心账户余额
      // 查该厂商游戏账户真实余额（顺带注册厂商账号）
      that.$apiFun
        .post('/api/userapimoney/' + name, {})
        .then(res => {
          if (res.code == 200) {
            that.gtGameBalance = Number(res.data.balance) || 0;
          }
        })
        .catch(() => {});
    },
    // 弹窗：快捷金额
    gtQuick(v) {
      let plat = Math.floor(Number(this.$store.state.userInfo.balance) || 0);
      this.gtAmount = v === 'all' ? String(plat) : String(v);
    },
    gtClose() {
      this.gtShow = false;
    },
    gtGoRecharge() {
      this.gtShow = false;
      this.goNav('/recharge');
    },
    // 转入并进入
    gtConfirm() {
      let that = this;
      let plat = Number(that.$store.state.userInfo.balance) || 0;
      let amount = parseInt(that.gtAmount, 10);
      if (!amount || amount < 1) {
        that.showTost(0, '请输入转入金额');
        return;
      }
      if (amount > plat) {
        that.showTost(0, '转入金额不能大于中心账户余额');
        return;
      }
      that.gtLoading = true;
      that.$apiFun
        .post('/api/transfer', { amount: amount, sourcetype: 'userbalance', targettype: that.gtName })
        .then(res => {
          that.gtLoading = false;
          if (res.code == 200) {
            that.getBalance();
            that.gtShow = false;
            that.gtEnterGame();
          } else {
            that.showTost(0, res.message || '转入失败');
          }
        })
        .catch(() => {
          that.gtLoading = false;
          that.showTost(0, '转入失败，请重试');
        });
    },
    // 直接进入（游戏账户已有额度）
    gtEnterDirect() {
      if (this.gtGameBalance < 1) {
        this.showTost(0, '游戏账户暂无额度，请先转入');
        return;
      }
      this.gtShow = false;
      this.gtEnterGame();
    },
    gtEnterGame() {
      this.goNav(`/gamePage?name=${this.gtName}&type=${this.gtType}&code=${this.gtCode}`);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();
      document.execCommand('copy');
      this.showTost(1, '复制成功！');
    },
    goNav(url) {
      let that = this;

      if (url == '/mine') {
        if (!that.$store.state.token) {
          this.$router.push({ path: '/login' });
        }
      }
      if (url == '/hongbao' || url == '/transfer') {
        if (!that.$store.state.token) {
          that.$dialog
            .confirm({
              message: '精彩内容等你来体验，快来登录吧！',
            })
            .then(() => {
              this.$router.push({ path: '/login' });
            });

          return;
        }
        if (url == '/hongbao' && that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }

      this.$router.push({ path: url });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    // 不刷新页面更新用户余额
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeDaoTime();
            that.$router.push({ path: '/login' });
          }
        })
        .catch(res => {});
    },
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 4300);
    },
    // 不刷新页面跟新用户信息
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
        }
      });
    },
    // 刷新页面更新信息
    getUserInfoShowLoding() {
      let that = this;
      that.showLoading();
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.hideLoading();
        }
      });
    },
    // 获取代理
    getAgentLoginUrl() {
      let that = this;
      that.$parent.goNav(`/gamePage?dailiD=1`);
    },
    openKefu() {
      let that = this;
      that.goNav(`/kefu`);
    },
    openTg() {
      let url = this.$store.state.appInfo.tg_url;
      if (url) {
        window.open(url, '_blank');
      }
    },
    showTost(type, title) {
      let str = type ? 'success' : 'danger';
      this.$notify({ type: str, message: title });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
  },
  mounted() {},
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>

<style>
/* @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css';
 @import '../static/css/registermember.css'; */

.meLoading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.62);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #069b71;
}

.step .van-tab--active {
  color: #fff;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjM2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0wIDB2MzZoMjQwLjgzN0wyNTAgMThsLTkuMTYzLTE4eiIgZmlsbD0iIzA2OUI3MSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) no-repeat 100% / cover;
}

.step .van-tabs--line .van-tabs__wrap {
  height: 27px;
}
.metransRecord .van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #069b71;
  border-radius: 22px;
}
.metransRecord .van-tabs__nav--card {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  border: none;
}
.metransRecord .van-tabs__nav--card .van-tab {
  color: #000;
}

/* 页眉 */

.pageTop {
  background-color: #ffffff;
  color: rgb(0, 0, 0);
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
}

.acts .van-tabs__line {
  background-color: #7a1330 !important;
}
.acts .van-tab--active {
  color: #8a1a34 !important;
}

.van-nav-bar .van-icon {
  color: #000;
}
.van-nav-bar {
  background-color: #ffffff;
}
.van-nav-bar__arrow {
  font-size: 24px;
}
.van-nav-bar__title {
  font-weight: 700;
}

.bancgs {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 30px;
  opacity: 0.8;
  z-index: 200;
}
p {
  margin-block-start: 5px !important;
  margin-block-end: 5px !important;
}
.inputsw {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 999;
  cursor: pointer;
}
.van-tab--active {
  color: #8a1a34;
}
.van-tabs__line {
  background-color: #7a1330;
}
.van-cell {
  padding: 5px 8px;
}
.sdg .van-field__label {
  width: 0.2rem;
}
[class*='van-hairline']:after {
  border: none;
}
.sdgg .van-popup {
  border-radius: 15px 15px 0 0;
}

.stddss .van-field__control {
  font-size: 0.5rem;
}

.van-button--info {
  color: #fff;
  background: linear-gradient(135deg, #e6c877, #c69a3f) !important;
  border: none !important;
  text-shadow: 0 1px 1px rgba(120, 80, 0, 0.28);
}

/* 悬浮客服 */
.floatKf {
  position: fixed;
  right: 10px;
  bottom: 158px;
  z-index: 190;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.floatKf .fkBtn {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #64748b;
  margin-top: 12px;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.18);
  cursor: pointer;
}
.floatKf .fkBtn img {
  width: 30px;
  height: 30px;
  display: block;
}
.floatKf .fkBtn svg {
  width: 22px;
  height: 22px;
}
.floatKf .fkBtn span {
  font-size: 9px;
  line-height: 1;
  margin-top: 1px;
  transform: scale(0.92);
}
.floatKf .fkBtn.kf span {
  color: #b8860b;
}
.floatKf .fkBtn.tg {
  background: linear-gradient(135deg, #37bbfe, #229ed9);
  color: #fff;
}

/* 转账钱包：转入额度弹窗 */
.gtSheet {
  padding: 20px 18px calc(18px + constant(safe-area-inset-bottom));
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #fffdf8 0%, #ffffff 60%);
}
.gtHead {
  text-align: center;
  font-size: 17px;
  font-weight: 800;
  color: #7a1330;
  letter-spacing: 1px;
  margin-bottom: 16px;
}
.gtRows {
  background: linear-gradient(135deg, #fbf3df, #f6ead0);
  border: 1px solid rgba(201, 154, 63, 0.35);
  border-radius: 12px;
  padding: 4px 14px;
  margin-bottom: 16px;
}
.gtRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
  font-size: 14px;
  color: #8a6a2f;
}
.gtRow + .gtRow {
  border-top: 1px dashed rgba(201, 154, 63, 0.3);
}
.gtRow b {
  font-size: 17px;
  font-weight: 800;
  color: #7a1330;
}
.gtField {
  margin-bottom: 12px;
}
.gtField input {
  width: 100%;
  box-sizing: border-box;
  height: 46px;
  padding: 0 14px;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  border: 1px solid rgba(201, 154, 63, 0.5);
  border-radius: 10px;
  background: #fff;
  outline: none;
}
.gtChips {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}
.gtChips span {
  flex: 1;
  text-align: center;
  padding: 9px 0;
  font-size: 14px;
  font-weight: 600;
  color: #9a7b3f;
  background: #fff;
  border: 1px solid rgba(201, 154, 63, 0.45);
  border-radius: 8px;
  cursor: pointer;
}
.gtChips span:active {
  background: linear-gradient(135deg, #e6c877, #c69a3f);
  color: #fff;
}
.gtTip {
  font-size: 12px;
  color: #b3402f;
  text-align: center;
  margin-bottom: 12px;
}
.gtBtns {
  display: flex;
  gap: 10px;
}
.gtBtn {
  flex: 1;
  height: 46px;
  border: none;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.gtBtn.ghost {
  flex: 0 0 84px;
  background: #f1f0ee;
  color: #8a7a5a;
}
.gtBtn.direct {
  background: #fff;
  color: #7a1330;
  border: 1px solid #7a1330;
}
.gtBtn.primary {
  color: #fff;
  background: linear-gradient(135deg, #8a1a34, #641530);
  box-shadow: 0 4px 12px rgba(122, 19, 48, 0.32);
}
.gtBtn.primary:disabled {
  background: #cbb9be;
  box-shadow: none;
}
.gtRecharge {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  font-weight: 600;
  color: #c69a3f;
}
</style>



// WEBPACK FOOTER //
// src/App.vue